import {
  BuyingTools,
  NavigationMenuLabel,
} from '@/app/lcv/constants/top-navigation';
import {
  MUX_RS_DATA,
  MUX_ULTIMATE_DATA,
  PICKUP_2DOOR_DATA,
  PICKUP_4DOOR_DATA,
  SPARK_DATA,
  V_CROSS_DATA,
  X_SERIES_DATA,
} from '@/app/lcv/contents/products/maxforce/model-data';
import type { LcvModelData } from '@/app/lcv/types/model-data';
import type { MenuLcvModelCategoryType } from '@/app/lcv/types/top-navigation';
import type {
  MenuLinkType,
  NavItemType,
  NavMenuItemType,
} from '@/app/types/top-navigation';

export const NAV_BUYING_TOOLS: MenuLinkType[] = [
  {
    label: BuyingTools.compare,
    href: '/compare',
  },
  {
    label: BuyingTools.calculator,
    href: '/calculator',
  },
  {
    label: BuyingTools.dealer,
    href: '/dealer',
  },
  {
    label: BuyingTools.downloadBrochure,
    href: '/download-brochure',
  },
];

export const OFFER_MENUS = [
  {
    label: 'ข้อเสนอพิเศษ',
    href: '/specialoffer',
  },
  {
    label: 'สินเชื่อและไฟแนนซ์',
    href: '/finance',
  },
];
const NAV_OFFER_MENUS: NavMenuItemType[] = [
  {
    children: OFFER_MENUS,
  },
];
export const SERVICE_MENUS = [
  {
    label: 'ศูนย์บริการ',
    href: '/service/service-center',
  },
  {
    label: 'รายการบำรุงรักษาตามระยะ',
    href: '/service/maintenance-list',
  },
  {
    label: 'อะไหล่สำหรับรถอีซูซุ',
    href: '/service/parts',
  },
  {
    label: 'คู่มือการใช้รถอีซูซุ',
    href: '/service/owners-manual',
  },
  {
    label: 'บริการรถบรรทุก',
    href: 'https://truck.isuzu-tis.com/lcs/service-center',
    target: '_blank',
  },
];
const NAV_SERVICE_MENUS: NavMenuItemType[] = [
  {
    children: SERVICE_MENUS,
  },
];
export const BENEFIT_MENUS = [
  {
    label: 'my-ISUZU',
    href: '/privileges/my-isuzu',
  },
  {
    label: 'สมาชิก “อีซูซุ ยิ่งเข้า ยิ่งคุ้ม”',
    href: '/privileges/ying-kao-ying-koom',
  },
  {
    label: 'อีซูซุมิว-เอ็กซ์ ดิ เอ็กซ์คลูซีฟ',
    href: '/privileges/mu-x-the-exclusive',
  },
  {
    labelHtml: 'การขยายการรับประกันรถ<span>อีซูซุ</span>',
    href: '/privileges/smart-protection',
  },
];
const NAV_BENEFIT_MENUS: NavMenuItemType[] = [
  {
    children: BENEFIT_MENUS,
  },
];
export const SHARE_MENUS = [
  {
    label: 'เรื่องราวจากผู้ใช้อีซูซุ',
    href: '/content-hub/experiences',
  },
  {
    label: 'เรื่องน่ารู้จากอีซูซุ',
    href: '/content-hub/expert',
  },
  {
    label: 'แกลเลอรี่',
    href: '/content-hub/inspiration',
  },
];
const NAV_SHARE_MENUS: NavMenuItemType[] = [
  {
    children: SHARE_MENUS,
  },
];
export const ABOUTUS_MENUS = [
  {
    label: 'คำถามที่พบบ่อย',
    href: '/faqs',
  },
  {
    label: 'ประวัติอีซูซุ',
    href: '/about-history',
  },
  {
    label: 'ข่าวสารและกิจกรรม',
    href: '/news-activities',
  },
  {
    label: 'ติดต่อตรีเพชรอีซูซุ',
    href: '/contact-us',
  },
  {
    label: 'สมัครงาน',
    href: 'https://career.tripetchgroup.com',
    target: '_blank',
  },
  {
    label: 'นโยบายความเป็นส่วนตัว',
    href: '/privacy-policy',
  },
];

export const PARTNERS_MENUS = [
  {
    label: 'อีซูซุลิสซิ่ง',
    href: 'https://www.isuzuleasing.com',
    target: '_blank',
  },
  {
    label: 'ตรีเพชรอินชัวรันส์เซอร์วิส',
    href: 'https://www.tripetchinsurance.com',
    target: '_blank',
  },
  {
    label: 'เทเลเทค',
    href: 'https://truck.isuzu-tis.com/lcs/teletec',
    target: '_blank',
  },
  {
    label: 'Truck2Hand',
    href: 'https://www.truck2hand.com',
    target: '_blank',
  },
];
const NAV_ABOUTUS_MENUS: NavMenuItemType[] = [
  {
    title: 'ตรีเพชร',
    children: ABOUTUS_MENUS,
  },
  {
    title: 'พันธมิตรของเรา',
    children: PARTNERS_MENUS,
  },
];

export const NAV_MENUS: NavItemType[] = [
  {
    label: NavigationMenuLabel.model,
    modelMenu: 'lcv',
  },
  {
    label: BuyingTools.title,
    isOnlyMobileNav: true,
    items: [
      {
        children: NAV_BUYING_TOOLS,
      },
    ],
  },
  {
    label: NavigationMenuLabel.offer,
    items: NAV_OFFER_MENUS,
  },
  {
    label: NavigationMenuLabel.service,
    items: NAV_SERVICE_MENUS,
  },
  {
    label: NavigationMenuLabel.benefit,
    items: NAV_BENEFIT_MENUS,
  },
  {
    label: NavigationMenuLabel.share,
    items: NAV_SHARE_MENUS,
  },
  {
    label: NavigationMenuLabel.aboutus,
    items: NAV_ABOUTUS_MENUS,
  },
];

export const NAV_LCV_MODEL_MENU: Record<
  MenuLcvModelCategoryType,
  LcvModelData[]
> = {
  pickup: [
    {
      label: V_CROSS_DATA.label,
      price: V_CROSS_DATA.price,
      image: V_CROSS_DATA.image,
      href: V_CROSS_DATA.href,
    },
    {
      label: PICKUP_4DOOR_DATA.label,
      price: PICKUP_4DOOR_DATA.price,
      image: PICKUP_4DOOR_DATA.image,
      href: PICKUP_4DOOR_DATA.href,
    },
    {
      label: PICKUP_2DOOR_DATA.label,
      price: PICKUP_2DOOR_DATA.price,
      image: PICKUP_2DOOR_DATA.image,
      href: PICKUP_2DOOR_DATA.href,
    },
    {
      label: SPARK_DATA.label,
      price: SPARK_DATA.price,
      image: SPARK_DATA.image,
      href: SPARK_DATA.href,
    },
    {
      label: X_SERIES_DATA.label,
      price: X_SERIES_DATA.price,
      image: X_SERIES_DATA.image,
      href: X_SERIES_DATA.href,
    },
  ],
  suv: [
    {
      label: MUX_RS_DATA.label,
      price: MUX_RS_DATA.price,
      image: MUX_RS_DATA.image,
      href: MUX_RS_DATA.href,
      specialBadge: true,
    },
    {
      label: MUX_ULTIMATE_DATA.label,
      price: MUX_ULTIMATE_DATA.price,
      image: MUX_ULTIMATE_DATA.image,
      href: MUX_ULTIMATE_DATA.href,
    },
  ],
};
